import type { Resolver } from 'cpool-schemas';
import type { z } from 'zod';

import { UserGroupContextZod, UsersTableDefinitionZod } from '../tables';

type Arguments = Record<string, unknown>;

export const schemaUserResolver_Get = UsersTableDefinitionZod.merge(UserGroupContextZod).nullable();

export type SchemaUserResolver_Get = z.infer<typeof schemaUserResolver_Get>;

export type UserResolver_Get = Resolver<Arguments, SchemaUserResolver_Get>;
